export const mdpReadOnlyInput = () => {
    return {
        restrict: 'A',
        link: (scope, element) => {
            element.find("input")[0].setAttribute("readonly", "true");
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/common/directives/mdp-readonly-input.directive.js